import * as React from 'react';

import { ButtonProps, UIButton } from '~shared/components/buttons';

type Props = {
  children: NonNullable<React.ReactNode>;
  icon?: React.ReactElement;
} & ButtonProps;

export function ReportOptionButton({ children, icon, ...buttonProps }: Props) {
  return (
    <div className="flex-auto pt-4 pl-4">
      <UIButton className="w-full" {...buttonProps}>
        <div className="flex items-center justify-between md:justify-center">
          <div className="md:order-2">{children}</div>
          <div className="flex md:order-1 md:pr-2 md:-ml-1">{icon}</div>
        </div>
      </UIButton>
    </div>
  );
}
